module.exports = __webpack_public_path__ + "img/Rausschwimmen.caaf7881.svg";